(() => {
  const mobile = matchMedia('(max-width: 768px)');
  function footer() {
    document.querySelectorAll('.footer__block[data-type="menu"]').forEach((block, i) => {
      const title = block.querySelector('.footer__title'), list = block.querySelector('.footer__menu');
      if (!title || !list) return;
      let button = title.querySelector('button');
      if (!button) {
        const label = title.textContent.trim(); title.textContent = '';
        const text = document.createElement('span'); text.className = 'hd-footer-static'; text.textContent = label;
        button = document.createElement('button'); button.type = 'button'; button.className = 'hd-footer-toggle'; button.textContent = label;
        list.id ||= `hd-footer-links-${i}`;
        button.setAttribute('aria-controls', list.id); button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', () => { const open = button.getAttribute('aria-expanded') !== 'true'; button.setAttribute('aria-expanded', String(open)); list.hidden = !open; });
        title.append(text, button);
      }
      list.hidden = mobile.matches && button.getAttribute('aria-expanded') !== 'true';
    });
  }
  footer(); mobile.addEventListener('change', footer); document.addEventListener('shopify:section:load', footer);
  new MutationObserver(records => {
    if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('.footer__block')||n.querySelector('.footer__block'))))) footer();
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:block:select', e => { const block = e.target.closest('.footer__block'), button = block?.querySelector('.hd-footer-toggle'); if (button) { button.setAttribute('aria-expanded','true'); block.querySelector('.footer__menu').hidden = false; } });
  document.addEventListener('click', e => { document.querySelectorAll('.hd-desktop-nav>details[open]').forEach(d => { if (!d.contains(e.target)) d.open = false; }); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('.hd-desktop-nav>details[open]').forEach(d => { d.open = false; d.querySelector('summary').focus(); }); });
  document.addEventListener('change', e => { if (e.target.matches('[data-hd-bag-check]')) e.target.closest('[data-hd-product-gift-addon]').querySelector('[data-hd-bag-quantity]').hidden = !e.target.checked; });
  // Both native HTML and AJAX forms include the optional bag in the same request.
  document.addEventListener('formdata', e => {
    const addon = e.target.querySelector?.('[data-hd-product-gift-addon]');
    if (!addon?.querySelector('[data-hd-bag-check]')?.checked) return;
    const fd = e.formData;
    if (!fd.get('id') || fd.has('items[0][id]')) return;
    const itemKeys = [...fd.keys()].filter(k => k === 'id' || k === 'quantity' || k === 'selling_plan' || k.startsWith('properties['));
    for (const key of new Set(itemKeys)) {
      const values = fd.getAll(key), nested = key.startsWith('properties[') ? 'items[0][properties]' + key.slice(10) : `items[0][${key}]`;
      fd.delete(key); for (const value of values) fd.append(nested, value);
    }
    if (!fd.has('items[0][quantity]')) fd.set('items[0][quantity]', '1');
    fd.set('items[1][id]', addon.dataset.giftVariantId);
    fd.set('items[1][quantity]', String(Math.max(1, Math.min(5, Number(addon.querySelector('select').value) || 1))));
    fd.set('items[1][properties][_Priedas]', 'Dovanų maišelis');
  }, true);
})();
